import { createVNode, normalizeProps } from "inferno";
import BaseCell from './BaseCell';
export default class HeaderCell extends BaseCell {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    const {
      children
    } = this.props;
    const props = this.getRenderProps('cell');
    return normalizeProps(createVNode(1, "td", null, children, 0, { ...props
    }));
  }

}
//# sourceMappingURL=Cell.js.map